import React from 'react';

export default function UconnLogo(props){
    return (
      <>
        <svg
          version='1.1'
          id='layer'
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          space='preserve'
          viewBox='14.1 260.2 623.63 130.43'
          height={props.height}
        >
          {' '}
          <style type='text/css'> </style>{' '}
          <g>
            {' '}
            <g>
              {' '}
              <g>
                {' '}
                <path
                  class='st0'
                  d='M96.7,362.7c-8.4,2.5-17,5.5-27.5,5.5c-10.5,0-19.1-3.1-27.5-5.5v-99H14.1v112.7c15,8.8,34.1,14.2,55,14.2 				c20.7,0,40.1-5.3,55.1-14.2V263.8H96.7V362.7z'
                ></path>{' '}
                <path
                  class='st0'
                  d='M225.5,288v18.3H253v-32.1c-15-8.8-34.1-13.9-55-13.9c-20.7,0-39.8,5.1-54.8,13.9v102.5 				c15,8.6,34.1,13.8,54.8,13.8c20.9,0,40.1-5.1,55-13.8v-37.4h-27.5v23.4c-8.2,2.5-17,3.9-27.5,3.9c-10.5,0-19.1-1.4-27.3-3.9V288 				c8.2-2.5,16.8-3.9,27.3-3.9C208.5,284.1,217.3,285.5,225.5,288z'
                ></path>{' '}
                <path
                  class='st0'
                  d='M272.5,274v102.7c15,8.6,34.1,13.8,55.1,13.8c20.7,0,40.1-5.1,55-13.8V274c-15-8.6-34.1-13.8-55.1-13.8 				C306.8,260.3,287.5,265.4,272.5,274z M355.1,362.7c-8.4,2.5-17.1,3.9-27.5,3.9c-10.5,0-19.1-1.4-27.5-3.9V288 				c8.4-2.7,17-3.9,27.5-3.9c10.5,0,19.1,1.4,27.5,3.9V362.7z'
                ></path>{' '}
                <polygon
                  class='st0'
                  points='485.2,351 484.6,351 430,263.8 400.6,263.8 400.6,386.8 425.4,386.8 425.4,299.5 426.3,299.5  				480.9,386.8 510.3,386.8 510.3,263.8 485.2,263.8 			'
                ></polygon>{' '}
                <polygon
                  class='st0'
                  points='612.7,351 612.1,351 557.5,263.8 528.1,263.8 528.1,386.8 552.9,386.8 552.9,299.5 553.8,299.5  				608.4,386.8 637.7,386.8 637.7,263.8 612.7,263.8 			'
                ></polygon>{' '}
              </g>{' '}
            </g>{' '}
          </g>{' '}
        </svg>
      </>
    );
}